import { useTranslation } from 'react-i18next';
import { isMobile } from 'utils/is-mobile';
import { GlobalIcon } from 'components/GlobalIcon';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

type TAdvancedShowAllEventsUnderlinedProps = {
  onClick: () => void;
  showSkeleton?: boolean;
  className?: string;
  bottomNavSwitchersHeight?: number;
};

export const AdvancedShowAllEventsUnderlined = ({
  onClick,
  showSkeleton,
  className,
  bottomNavSwitchersHeight
}: TAdvancedShowAllEventsUnderlinedProps) => {
  const { t } = useTranslation();

  return (
    <div
      {...(isMobile() &&
        bottomNavSwitchersHeight && {
          style: { bottom: bottomNavSwitchersHeight - 1 }
        })}
      className={`advancedShowAllEventsUnderlined ${className ?? ''}`}
    >
      <div
        className="advancedShowAllEventsUnderlined__content"
        onClick={onClick}
      >
        <span className="advancedShowAllEventsUnderlined__text">
          {showSkeleton ? (
            <Skeleton.Button
              active
              style={{
                width: 150,
                height: 24
              }}
            />
          ) : (
            t('sportsbook.showAllEvents')
          )}
        </span>
        {!showSkeleton && (
          <GlobalIcon
            lib="generic"
            name="arrowupright"
            theme="default"
            size={24}
            color="var(--v3-primary-color)"
          />
        )}
      </div>
    </div>
  );
};
